import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { TransactionStatus } from "../../interfaces/transaction";

interface PaymentStatusLabelProps {
    value: TransactionStatus;
}

export function PaymentStatusLabel({ value }: PaymentStatusLabelProps) {
    const { palette } = useTheme();

    const statusMap: Record<
        TransactionStatus,
        { label: string; color: string }
    > = {
        paid: { label: "Pago", color: palette.success.main },
        cancelled: { label: "Cancelado", color: palette.error.main },
        refunded: { label: "Reembolsado", color: palette.primary.main },
        denied: { label: "Negado", color: palette.error.main },
        pending: { label: "Pendente", color: palette.warning.main },
    };

    const { label, color } = statusMap[value];

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                borderRadius: 1,
                color,
                backgroundColor: `${color}18`,
                border: `1px solid ${color}40`,
                fontWeight: 500,
            }}
        />
    );
}
